import { useState } from "react";

import CanvasSvg from "./CanvasSvg";
import Toolbar from "./Toolbar";
import { Spinner } from "../Spinner";
import ColorLimitBar from "./ColorLimitBar"; // Add this import

export default function EditSvg(props) {
    const [loading, setLoading] = useState(true);
    const [processLoading, setProcessLoading] = useState(false);
    const [editor, setEditor] = useState();
    const [mode, setMode] = useState("fill");
    const [brushSize, setBrushSize] = useState(1);
    const [brushColor, setBrushColor] = useState("#7928CA");
    const [showColorLimitBar, setShowColorLimitBar] = useState(false);
    const [colorLimit, setColorLimit] = useState(10);
    return (
        <div className="mx-auto relative flex w-full h-full flex-col">
            <div className="hidden w-28 mr-3">
                <div className="flex flex-col items-center justify-center"></div>
            </div>
            <div
                className={`overflow-hidden flex  justify-center h-full canvas-mode-${mode} canvas-brush-${brushSize}`}
            >
                {!props.children && (
                    <div className="">
                        <CanvasSvg
                            key="canvas"
                            image={props.image}
                            svgData={props.svgData}
                            mode={mode}
                            brushSize={brushSize}
                            brushColor={brushColor}
                            removeBackgroundOnInit={props.removeBackgroundOnInit}
                            onColorChanged={(color) => setBrushColor(color)}
                            onLoginNeeded={props.onLoginNeeded}
                            onPremiumNeeded={props.onPremiumNeeded}
                            onError={props.onError}
                            onLoading={({ loading }) => {
                                setProcessLoading(loading);
                            }}
                            onEditorReady={(editor) => setEditor(editor)}
                            className={
                                "mx-auto h-full relative [&>*>svg]:w-full [&>*>svg]:h-full [&>div]:w-full [&>div]:h-full " +
                                (loading ? "" : "image-display ") +
                                (props.children ? "opacity-0" : "") +
                                (processLoading ? "opacity-40 " : "")
                            }
                            onDoneInit={() => setLoading(false)}
                        />
                    </div>
                )}
                {props.children && (
                    <div className="inset-0 flex right-32">
                        {props.children}
                    </div>
                )}
                {processLoading && (
                    <div className="absolute inset-0 flex justify-center items-center">
                        <div className="w-16 h-16">
                            <Spinner />
                        </div>
                    </div>
                )}

                <ColorLimitBar
                    show={showColorLimitBar}
                    colorLimit={colorLimit}
                    setColorLimit={setColorLimit}
                    editor={editor}
                    setShowColorLimitBar={setShowColorLimitBar}
                />
            </div>

            <div className="">
                <div className="mx-3 flex justify-center">
                    {(editor || (props.children && props.showToolbar)) && (
                        <Toolbar
                            isSubscribed={props.isSubscribed}
                            enabled={!processLoading && !props.children}
                            mode={mode}
                            brushSize={brushSize}
                            brushColor={brushColor}
                            setBrushSize={(brushSize) =>
                                setBrushSize(brushSize)
                            }
                            setBrushColor={(color) => setBrushColor(color)}
                            setMode={(mode) => setMode(mode)}
                            showColorLimitBar={showColorLimitBar}
                            setShowColorLimitBar={(val) => {
                                setShowColorLimitBar(val);
                            }}
                            clearTooltip={() => setShowTooltip(false)}
                            removeBackground={() => editor?.removeBackground()}
                            quantizeColors={(numColors) =>
                                editor?.quantizeColors(numColors)
                            }
                            undo={() => editor?.undo()}
                            redo={() => editor?.redo()}
                            download={() => {
                                if (props.isSubscribed) {
                                    editor?.download();
                                } else {
                                    props.onSubscriptionNeeded();
                                }
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
